import { PermissionFields } from './Resource'
import { User } from './User'
import { EditorValueJSON } from '@follow/farte'
import { CustomFile } from './File'

export interface QuestionConfig {
  minPoints?: number
  maxPoints?: number
  leftValue: number
  rightValue: number
  stepValue: number
  inverted: boolean
}

interface BaseScoreConfig {
  title: string
  percentage: boolean
  inverted: boolean
}

export interface PercentageScoreConfig extends BaseScoreConfig {
  percentage: true
}

export interface MinMaxScoreConfig extends BaseScoreConfig {
  percentage: false
  min: number
  max: number
}

export type ScoreConfig = MinMaxScoreConfig | PercentageScoreConfig

export enum QuestionType {
  Text = 'TEXT',
  Slider = 'SLIDER',
  Select = 'SELECT',
  YesNo = 'YES_NO', // Géré comme un Radio
  QCU = 'RADIO',
  QCM = 'BTN_GROUP_MULTIPLE',
  BtnGroup = 'BTN_GROUP',
  Date = 'DATE',
}

export interface BaseAnswer {
  id: number
  title: string
  displayOrder: number
  points: number | null
  textOutput?: EditorValueJSON | null
  imageFile: Omit<CustomFile, 'creator' | 'owner'> | null
}

export interface BaseQuestion extends PermissionFields {
  id: number
  title: string
  type: QuestionType
  displayOrder: number
  parentAnswerId: number | null
  parentQuestionId: number | null
  code: string | null // Un truc pour le calcul des scores à point
  config?: QuestionConfig
  private: boolean
  documentTemplates: [
    {
      id: number
      title: string
    },
  ]
}

export interface BaseQuestionnaire extends PermissionFields {
  id: number
  tagIds: ReadonlyArray<string>
  title: string
  scoreConfig: ScoreConfig | null
  scoreValue: number | null | undefined
  author: User
  private: boolean
  duplicatedFrom: number
  sharedWithUsers: User[]
  owner: User
}

export const defaultAnswerTitle = 'Réponse sans titre'
export const defaultQuestionLabels = {
  [QuestionType.Text]: 'Nouvelle question (Texte libre)',
  [QuestionType.Slider]: 'Nouvelle question (Slider)',
  [QuestionType.YesNo]: 'Nouvelle question (Oui / Non)',
  [QuestionType.QCU]: 'Nouvelle question (QCU)',
  [QuestionType.QCM]: 'Nouvelle question (QCM)',
  [QuestionType.Date]: 'Nouvelle question (Date)',
}
